import GoalWidget from "./GoalWidget";
export default GoalWidget;
